import React from "react";
import {Typography} from "antd"
import {currencyFormat} from "../../../../components/permissions/functions";

const {Text} = Typography

export default class FreeAmountDataField extends React.Component {
    render() {

        const {edit, propertie, value, onChange} = this.props

        return <Text strong>{currencyFormat(value)}</Text>
    }
}
